import React from 'react';

function About() {
  return (
    <div className="page">
      <h1>About Us</h1>
      <p>
        We are a passionate team of developers, designers, and innovators 
        dedicated to crafting high-quality, user-friendly web applications. 
        Our mission is to combine creativity and technology to deliver 
        solutions that drive results and make a lasting impact.
      </p>
      <p>
        This platform is built as a demonstration of modern React development 
        practices, including component-based architecture, state management, 
        and dynamic routing with React Router.
      </p>
      <img
        src="https://images.unsplash.com/photo-1556761175-4b46a572b786?crop=entropy&cs=tinysrgb&fit=crop&w=900&h=300&q=80"
        alt="About Our Team"
        className="banner"
      />
      <ul>
        <li>🚀 Developed with React & modern JavaScript</li>
        <li>🛣 Powered by React Router for seamless navigation</li>
        <li>🎨 Fully responsive and mobile-friendly design</li>
        <li>💡 Scalable architecture for future growth</li>
      </ul>
    </div>
  );
}

export default About;
